export default {
  title: 'Marcas',
  form: {
    name: {
      placeholder: 'Buscar marca...',
    },
  },
  fields: {
    id: '#',
    name: 'Nombre',
    address: 'Dirección',
    subdomain: 'Subdominio',
    shop_url: 'URL de la tienda',
    companies: 'Empresas',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Aún no hay marcas',
  modals: {
    delete_franchise: {
      title: '¿Seguro que quieres eliminar la marca {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Añadir marca',
    export_restaurants: 'Exportar restaurantes',
    edit: 'Editar',
    delete: 'Eliminar',
    view_dashboard_as_owner: 'Ver panel como propietario',
    open_shop: 'Abrir tienda',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_delete_franchise: 'Error al eliminar la marca',
    franchise_got_deleted: 'Marca eliminada',
    failed_to_create_magic_link: 'Error al crear el enlace mágico',
    no_owner_to_log_in_as: 'No hay propietario del restaurante con quien iniciar sesión',
  },
};
